module.exports = __webpack_public_path__ + "static/media/Tape.cae42026.png";